// `createApiClient` — what a consumer calls.
//
// The methods come from `src/generated/client.ts`, which is generated from the OpenAPI document;
// this file only binds them to a transport and hands back the two escape hatches a real
// application eventually needs.
import { createOperations } from "./generated/client.js";
import { createTransport } from "./runtime/index.js";
export function createApiClient(options) {
    const transport = createTransport(options);
    return { ...createOperations(transport), baseUrl: options.baseUrl, transport };
}
//# sourceMappingURL=client.js.map